import React from 'react';

import {Helmet} from 'views/module';

import {useParams} from 'views/module';

import CaregiverDetailScene from 'views/scenes/caregiver/detail/CaregiverDetail';

const CaregiverDetail = (props) => {
  const params = useParams();

  const caregiverRnOrShortId = params.caregiverRnOrShortId;

  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <CaregiverDetailScene
        caregiverRnOrShortId={caregiverRnOrShortId}
      />
    </>
  );
};

export default CaregiverDetail;
